import React from "react";
import logoSrc from "../assets/anfield_logo_white.png";

/**
 * The logo PNG is 500×143 but the artwork only occupies y40–y123 — roughly 41%
 * of the file is transparent padding, and it sits off-centre (40px above the
 * mark, 19px below). Sizing the <img> directly therefore renders the logo far
 * smaller than the given height implies.
 *
 * This clips that padding away so `height` describes the *visible* mark.
 */
const FILE_H = 143;
const CONTENT_H = 84; // measured non-transparent bounds
const CONTENT_TOP = 40;

export default function Logo({ height = 38, className = "" }) {
  const imgH = Math.round((height * FILE_H) / CONTENT_H);
  const offset = Math.round((imgH * CONTENT_TOP) / FILE_H);

  return (
    <span
      className={`inline-block overflow-hidden align-middle transition-all duration-500 ${className}`}
      style={{ height }}
    >
      <img
        src={logoSrc}
        alt="Anfield Services Limited"
        className="max-w-none transition-all duration-500"
        style={{ height: imgH, marginTop: -offset }}
      />
    </span>
  );
}
